export const companyInfo = {
  name: "江苏道鼎升工程检测有限公司",
  shortName: "江苏道鼎升",
  legalRepresentative: "赵林涛",
  phone: "16680266101",
  email: "704844794@qq.com",
  address: "苏州市吴中区丹枫路389号",
  serviceArea: "江苏、上海及长三角区域",
  serviceCities: ["江苏", "上海", "南京", "苏州", "无锡", "常州", "南通", "扬州", "镇江", "泰州", "长三角区域"],
  icp: "苏ICP备2024065706号",
  publicSecurityRecord: "苏公网安备32050602013590号",
  publicSecurityUrl: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050602013590"
};

export const companySummary =
  "江苏道鼎升工程检测有限公司专注为开发商、建设单位、物业单位、工程项目和住宅交付项目提供精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、整改复查和工程质量检测服务。公司服务覆盖江苏、上海及长三角区域，重点协助项目在精装入场阶段同步发现质量风险，在施工和交付过程中形成问题清单、整改建议与复查闭环。";

export const serviceTypeCards = [
  {
    type: "primary",
    title: "对公工程查验服务",
    path: "/services",
    audience: ["开发商", "建设单位", "物业单位", "工程项目", "精装修项目", "住宅交付项目"],
    services: ["精装入场查验", "过程质量巡检", "分户查验", "一房一验", "交付前预验收", "整改复查", "工程质量检测", "问题清单与报告输出"],
    description:
      "以项目制、批量化和流程化方式参与住宅项目质量管理，从精装入场阶段同步进场，到过程巡检、分户查验、交付前预验收和整改复查，帮助项目团队把质量问题前置发现并推动闭环。"
  },
  {
    type: "secondary",
    title: "对私业主验房服务",
    path: "/owner-inspection",
    audience: ["新房业主", "精装修房业主", "毛坯房业主", "收房前需要第三方陪验的个人客户"],
    services: ["新房验房", "精装房验房", "毛坯房验房", "收房陪验", "问题记录", "整改建议", "可选复查"],
    description:
      "作为独立页面提供个人业主验房说明，帮助业主在收房前后识别墙地面、门窗、水电、厨卫、空鼓、开裂、渗漏等常见问题。当前不展示虚构案例、评价或成交数量。"
  }
];

export const serviceProcess = [
  "项目沟通",
  "进场策划",
  "现场查验",
  "问题清单 / 报告输出",
  "整改复查闭环"
];

export const serviceProcessDetails = [
  {
    title: "项目沟通与进场策划",
    description: "确认项目城市、楼栋范围、交付批次、预计户数、精装入场或交付节点，并明确查验目标和报告口径。"
  },
  {
    title: "精装入场 / 阶段查验",
    description: "根据现场进度同步进场，围绕施工移交、精装入场、样板段、批量施工和交付前节点开展查验。"
  },
  {
    title: "分户与专项问题记录",
    description: "按户、楼栋、专业类别或专项问题记录墙地面、门窗、厨卫、水电、渗漏、空鼓、安装质量等问题。"
  },
  {
    title: "清单与阶段汇总",
    description: "输出问题照片、位置、分类、风险提示和整改建议，可按楼栋、标段、批次或专业维度汇总。"
  },
  {
    title: "整改复查闭环",
    description: "整改后按原问题清单复核，记录已整改、未整改、整改不到位和新增问题，帮助项目形成闭环资料。"
  }
];

export const ownerProcessDetails = [
  {
    title: "预约咨询",
    description: "沟通房屋位置、户型、交付状态、精装或毛坯类型，以及是否需要收房陪验或整改复查。"
  },
  {
    title: "确认房屋情况",
    description: "确认现场可进门条件、查验时间、业主关注重点和需要记录的问题类型。"
  },
  {
    title: "现场查验",
    description: "对墙面、地面、顶面、门窗、水电、厨卫、阳台、空鼓、渗漏等项目逐项检查。"
  },
  {
    title: "问题记录",
    description: "现场说明问题位置、表现和可能影响，并形成照片记录和问题说明。"
  },
  {
    title: "整改建议与可选复查",
    description: "提供后续整改沟通建议，开发商整改完成后可根据需要预约复查。"
  }
];

export const serviceAreas = [
  {
    title: "江苏工程查验",
    description: "服务覆盖南京、苏州、无锡、常州、南通、扬州、镇江、泰州等城市，重点支持住宅项目精装入场查验、过程巡检、分户查验和交付前预验收。"
  },
  {
    title: "上海住宅项目查验",
    description: "面向上海住宅交付、精装修项目、物业接管和工程质量管理场景，按项目节点安排现场查验与报告输出。"
  },
  {
    title: "长三角质量过程管控",
    description: "围绕长三角开发商、建设单位、物业单位和住宅交付项目，提供批量房源查验、问题清单和整改复查闭环支持。"
  }
];

export const commonInspectionItems = [
  "精装入场前移交条件、基层质量和交接问题",
  "墙面、地面、顶面空鼓开裂与观感质量",
  "门窗启闭、密封、五金、栏杆和安装质量",
  "厨卫、阳台、外窗及管根渗漏风险",
  "给排水、电气、弱电和开关插座功能",
  "精装修柜体、洁具、收口和设备安装质量",
  "开间进深、净高、垂直度、平整度等实测项目",
  "整改完成情况、遗留问题和新增问题复查"
];

export const whyChooseUs = [
  {
    title: "更早介入精装入场阶段",
    description: "不只在交付时验房，可在小区精装入场阶段同步参与查验、跟踪和问题记录。"
  },
  {
    title: "适配项目制批量查验",
    description: "按楼栋、批次、户数和交付节奏安排人员，支持分户清单、阶段汇总和专项报告。"
  },
  {
    title: "问题记录便于整改",
    description: "以照片、位置、分类、问题描述和整改建议输出资料，方便工程、客服、物业和施工单位协同。"
  },
  {
    title: "覆盖过程与交付节点",
    description: "服务覆盖精装入场、过程巡检、分户查验、交付前预验收和整改复查等关键节点。"
  },
  {
    title: "第三方视角辅助质量管理",
    description: "以第三方查验记录辅助项目发现质量风险，不做虚假承诺，强调可核查、可追溯的服务成果。"
  },
  {
    title: "覆盖江苏、上海及长三角",
    description: "围绕长三角住宅项目查验需求，支持跨城市项目沟通、人员进场和资料输出。"
  }
];

export const proofAssets = [
  {
    title: "问题清单样张展示",
    description: "用于展示分户问题记录、位置、照片和整改建议的版式方向。内容为示意展示，不代表真实客户数据。",
    image: "/img/issue-list-mockup.webp"
  },
  {
    title: "检测报告封面样张",
    description: "用于展示报告交付的专业版式方向。证书编号、客户名称、项目名称等真实信息需后续人工补充。",
    image: "/img/report-sample-mockup.webp"
  },
  {
    title: "整改闭环示意",
    description: "用于展示从问题发现、整改跟踪到复查确认的流程化资料形态。内容为样张展示。",
    image: "/img/recheck-closed-loop.webp"
  }
];

export const publicServices = [
  {
    slug: "jingzhuang-entry-inspection",
    path: "/services/jingzhuang-entry-inspection",
    title: "精装入场查验服务",
    shortTitle: "精装入场查验",
    serviceType: "精装入场查验",
    image: "/img/service-entry-inspection.webp",
    heroImage: "/img/service-entry-inspection.webp",
    summary:
      "面向住宅精装修项目，在精装入场或施工移交阶段同步进场，检查移交条件、基层质量、门窗洞口、厨卫阳台、防水渗漏风险和前置问题，帮助项目在批量装修前发现风险并形成整改清单。",
    metaDescription:
      "江苏道鼎升工程检测有限公司提供精装入场查验服务，面向开发商、建设单位、物业单位和住宅精装修项目，围绕精装入场阶段移交条件、基层质量、渗漏风险、门窗洞口和前置问题形成问题清单与整改建议。",
    targetUsers: ["开发商", "建设单位", "精装修项目", "工程项目管理方", "物业前介团队"],
    scenarios: ["精装修单位进场前移交查验", "样板段或首批施工前质量梳理", "土建移交精装前问题排查", "批量装修前风险预控"],
    checkItems: ["基层空鼓、开裂、平整度与观感质量", "门窗洞口、栏杆、五金与安装条件", "厨卫、阳台、外窗和管根渗漏风险", "给排水、电气、弱电预留条件", "公共部位与入户交接问题", "问题拍照定位、分类清单和整改建议"],
    deliverables: ["精装入场查验清单", "问题照片记录", "移交问题汇总", "整改建议", "阶段性查验报告"],
    faqs: [
      {
        question: "精装入场查验和交付验房有什么区别？",
        answer: "精装入场查验发生在精装修施工前或施工初期，重点是发现移交条件、基层质量和前置风险；交付验房更接近正式交付节点，关注最终成品质量和业主收房问题。"
      },
      {
        question: "精装入场查验是否适合批量住宅项目？",
        answer: "适合。可按楼栋、批次或样板段安排查验，帮助项目在批量装修前识别共性问题，减少后期集中返工。"
      },
      {
        question: "查验后能否继续做过程质量跟踪？",
        answer: "可以。精装入场查验可以与过程质量巡检、分户查验和整改复查组合，形成持续质量管控。"
      }
    ]
  },
  {
    slug: "process-quality-patrol",
    path: "/services/process-quality-patrol",
    title: "过程质量巡检服务",
    shortTitle: "过程质量巡检",
    serviceType: "工程质量过程管控",
    image: "/img/process-quality-patrol.webp",
    heroImage: "/img/process-quality-patrol.webp",
    summary:
      "在住宅项目施工、精装修和交付准备过程中开展阶段性巡检，对高频质量问题、施工节点、整改进度和风险点进行记录，帮助项目形成持续的质量跟踪机制。",
    metaDescription:
      "江苏道鼎升工程检测有限公司提供过程质量巡检服务，面向住宅项目、精装修项目和工程质量管理团队，围绕施工过程、节点查验、问题记录、阶段汇总和整改跟踪开展第三方巡检。",
    targetUsers: ["开发商工程管理部", "建设单位", "施工单位", "物业前介团队", "项目管理方"],
    scenarios: ["精装修施工过程巡检", "阶段性质量风险排查", "整改进度跟踪", "交付前问题前置管理"],
    checkItems: ["施工节点质量与成品保护", "墙地面、门窗、厨卫、水电和安装问题", "渗漏、空鼓、开裂等高频风险", "公共区域与交付动线问题", "整改状态和复查条件", "阶段性问题统计和风险提示"],
    deliverables: ["巡检问题清单", "阶段性问题汇总", "整改跟踪表", "专项风险提示", "复查建议"],
    faqs: [
      {
        question: "过程质量巡检需要多久做一次？",
        answer: "频次可根据项目节点、施工进度和交付计划确定，常见方式包括样板段巡检、阶段性巡检和交付前集中巡检。"
      },
      {
        question: "巡检是否只针对户内？",
        answer: "不只针对户内。可根据项目需要覆盖公共区域、交付动线、外窗周边、厨卫阳台、设备安装和重点专项问题。"
      },
      {
        question: "过程巡检能否和整改复查组合？",
        answer: "可以。巡检发现的问题可形成清单，整改后再进行复查确认，便于项目建立闭环记录。"
      }
    ]
  },
  {
    slug: "household-inspection",
    path: "/services/household-inspection",
    title: "分户查验与一房一验服务",
    shortTitle: "分户查验 / 一房一验",
    serviceType: "分户查验",
    image: "/img/household-inspection.webp",
    heroImage: "/img/household-inspection.webp",
    summary:
      "以单套房屋为单位开展标准化查验和记录，覆盖户内观感、功能、安装、渗漏、空鼓、实测实量等内容，输出分户问题清单和一房一验资料。",
    metaDescription:
      "江苏道鼎升工程检测有限公司提供分户查验和一房一验服务，按户记录住宅交付质量问题、照片、位置、分类和整改建议，适用于开发商、建设单位、物业单位和住宅批量交付项目。",
    targetUsers: ["开发商", "建设单位", "物业单位", "住宅交付项目", "项目客服与交付团队"],
    scenarios: ["住宅集中交付前分户排查", "一房一验资料建立", "交付前问题清单输出", "整改前后分户闭环管理"],
    checkItems: ["墙面、地面、顶面观感与空鼓开裂", "门窗、栏杆、五金和启闭功能", "厨卫、阳台、给排水和渗漏风险", "电路、开关插座和弱电点位", "空间尺寸、净高和平整度抽查", "分户照片记录与整改建议"],
    deliverables: ["分户问题清单", "一房一验记录", "问题照片与位置记录", "楼栋或批次汇总表", "整改复查记录"],
    faqs: [
      {
        question: "一房一验适合哪些项目？",
        answer: "适合住宅集中交付、精装房交付、毛坯交付、物业接管前查验和项目方需要建立分户资料的场景。"
      },
      {
        question: "分户查验能否按楼栋或批次汇总？",
        answer: "可以。问题可按户、楼栋、专业类别、施工单位或交付批次汇总，便于项目安排整改。"
      },
      {
        question: "查验清单是否包含照片？",
        answer: "可包含问题照片、位置说明、问题分类和整改建议，具体格式在服务方案中确认。"
      }
    ]
  },
  {
    slug: "pre-delivery-acceptance",
    path: "/services/pre-delivery-acceptance",
    title: "交付前预验收服务",
    shortTitle: "交付前预验收",
    serviceType: "交付前预验收",
    image: "/img/pre-delivery-acceptance.webp",
    heroImage: "/img/pre-delivery-acceptance.webp",
    summary:
      "在住宅正式交付、开放日或物业接管前，对户内、公共区域、交付动线和高频质量风险进行预查验，帮助项目在交付前形成整改清单与风险提示。",
    metaDescription:
      "江苏道鼎升工程检测有限公司提供交付前预验收服务，面向开发商、建设单位、物业单位和住宅交付项目，开展户内、公共区域、交付动线和高频质量风险排查，输出问题清单和整改建议。",
    targetUsers: ["开发商交付团队", "建设单位", "物业单位", "客户关系团队", "住宅交付项目"],
    scenarios: ["集中交付前预验收", "业主开放日前质量排查", "物业接管前查验", "交付动线与公共区域风险检查"],
    checkItems: ["户内成品质量和功能检查", "公共区域、门厅、楼梯、电梯厅等质量问题", "交付动线和重点观感问题", "渗漏、空鼓、开裂和安装缺陷", "交付现场高频投诉风险", "问题汇总与整改建议"],
    deliverables: ["交付前预验收清单", "公共区域问题记录", "高频风险汇总", "整改建议", "交付前复查记录"],
    faqs: [
      {
        question: "交付前预验收一般在什么时候做？",
        answer: "通常安排在正式交付、业主开放日或物业接管前，具体时间要结合项目施工完成度、整改窗口和交付计划确定。"
      },
      {
        question: "预验收是否包含公共区域？",
        answer: "可以包含。服务范围可覆盖户内、公共区域、交付动线、外立面相关部位和项目方指定专项。"
      },
      {
        question: "预验收后是否还能复查？",
        answer: "可以。整改完成后可按原问题清单进行复查，确认整改状态并补充遗留问题。"
      }
    ]
  },
  {
    slug: "recheck",
    path: "/services/recheck",
    title: "整改复查服务",
    shortTitle: "整改复查",
    serviceType: "整改复查",
    image: "/img/recheck-closed-loop.webp",
    heroImage: "/img/recheck-closed-loop.webp",
    summary:
      "针对前期精装入场查验、过程巡检、分户查验或交付前预验收发现的问题进行复核，记录整改状态、遗留问题和新增问题，帮助项目形成质量闭环。",
    metaDescription:
      "江苏道鼎升工程检测有限公司提供整改复查服务，对精装入场查验、过程巡检、分户查验、交付前预验收和工程质量检测问题进行复核确认，记录已整改、未整改、整改不到位及新增问题。",
    targetUsers: ["开发商", "建设单位", "施工单位", "物业单位", "项目客服与交付团队"],
    scenarios: ["查验问题整改完成后复核", "交付前最后一轮质量确认", "业主集中反馈问题复查", "项目问题闭环管理"],
    checkItems: ["按原问题清单逐项复查", "核对整改完成情况和整改质量", "记录未整改、整改不到位和新增问题", "对重点问题提供复查意见", "输出复查结果表与闭环建议"],
    deliverables: ["整改复查清单", "已整改/未整改状态记录", "复查照片", "遗留问题汇总", "闭环建议"],
    faqs: [
      {
        question: "整改复查是重新查全屋吗？",
        answer: "整改复查通常以原问题清单为主，同时关注整改过程中可能引发的新增问题。若需要全屋复查，可在方案中单独约定。"
      },
      {
        question: "可以复查项目方已有的问题清单吗？",
        answer: "可以。可基于项目方已有问题清单进行第三方复核，但需要提前确认清单格式、位置描述和现场条件。"
      },
      {
        question: "复查结果如何呈现？",
        answer: "会记录每项问题的整改状态、复查照片和遗留问题，便于项目继续跟进。"
      }
    ]
  },
  {
    slug: "quality-inspection",
    path: "/services/quality-inspection",
    title: "工程质量检测服务",
    shortTitle: "工程质量检测",
    serviceType: "工程质量检测",
    image: "/img/process-quality-patrol.webp",
    heroImage: "/img/process-quality-patrol.webp",
    summary:
      "围绕住宅及工程项目质量风险，提供第三方工程质量检测、专项检查、问题诊断、质量风险归类和整改建议，为项目质量管理提供可追溯依据。",
    metaDescription:
      "江苏道鼎升工程检测有限公司提供工程质量检测服务，面向开发商、建设单位、物业单位和工程项目，开展第三方检测评估、专项检查、问题诊断、质量风险归类和整改建议，覆盖江苏、上海及长三角区域。",
    targetUsers: ["开发商", "建设单位", "物业单位", "建筑企业", "项目管理方", "工程质量管理团队"],
    scenarios: ["工程节点质量评估", "交付前质量风险排查", "专项问题诊断", "第三方质量评估与管理改进"],
    checkItems: ["建筑观感与功能性质量检查", "渗漏、空鼓、开裂等高频问题排查", "门窗、栏杆、防水、给排水、电气等专项检查", "公共区域与户内质量问题记录", "项目质量风险归类分析", "整改建议与复核计划"],
    deliverables: ["工程质量检测记录", "专项问题清单", "质量风险分析", "整改建议书", "检测报告"],
    faqs: [
      {
        question: "工程质量检测适合哪些项目？",
        answer: "适用于住宅、商业、公寓、别墅及配套工程等项目，重点服务施工过程、移交前、交付前和质量提升阶段。"
      },
      {
        question: "能否只做某一类专项检测？",
        answer: "可以。可根据项目问题选择渗漏、空鼓、门窗、给排水、电气、公共部位等专项检查。"
      },
      {
        question: "检测报告是否包含整改建议？",
        answer: "报告可包含问题描述、位置记录、照片、风险提示和整改建议，便于项目团队安排整改和复查。"
      }
    ]
  }
];

export const services = publicServices;

export const ownerInspectionService = {
  path: "/owner-inspection",
  title: "业主新房验房与收房陪验服务",
  shortTitle: "业主验房",
  serviceType: "对私业主验房服务",
  image: "/img/public-home-inspection.webp",
  metaDescription:
    "江苏道鼎升工程检测有限公司提供业主验房、新房验房、精装修验房、毛坯房验房、收房陪验和第三方验房服务，面向江苏、上海及长三角个人业主，协助记录常见质量问题和整改建议。",
  summary:
    "面向个人业主提供精装房、毛坯房、新房交付前后的第三方验房服务，协助业主发现墙面、地面、水电、门窗、厨卫、空鼓、渗漏等常见质量问题，并形成清晰的问题记录和整改建议。",
  scenarios: ["新房即将交付，想提前了解房屋质量情况", "精装修房收房前需要第三方陪验", "毛坯房需要检查墙地面、水电、门窗等基础项目", "开发商整改后需要再次复查", "业主不熟悉验房流程，需要专业人员陪同查验"],
  checkItems: ["墙面、地面、顶面", "门窗、栏杆、五金", "厨房、卫生间、阳台", "给排水、电路、开关插座", "空鼓、开裂、渗漏、积水", "精装修细节与安装质量"],
  deliverables: ["现场问题说明", "问题照片记录", "整改建议", "可选复查服务"],
  faqs: [
    {
      question: "个人业主有必要请第三方验房吗？",
      answer: "如果业主不熟悉房屋质量问题和收房流程，第三方验房可以帮助更系统地检查墙地面、门窗、水电、厨卫、空鼓、渗漏等项目，并把问题记录清楚，便于后续沟通整改。"
    },
    {
      question: "精装修房验房主要看哪些问题？",
      answer: "精装修房通常重点关注墙地顶观感、门窗五金、柜体洁具、厨卫阳台、给排水、电气点位、渗漏风险、安装质量和细部收口。"
    },
    {
      question: "毛坯房验房和精装房验房有什么区别？",
      answer: "毛坯房更关注基础质量，如墙地面空鼓开裂、门窗栏杆、给排水和电气预留；精装房还需要检查成品安装、洁具柜体、设备功能和装修细节。"
    },
    {
      question: "验房后是否会提供问题清单？",
      answer: "可以根据服务约定提供现场问题说明、问题照片记录和整改建议，帮助业主后续与开发商或物业沟通。"
    },
    {
      question: "开发商整改后还能复查吗？",
      answer: "可以。整改完成后可预约复查，重点核对原问题是否整改完成，以及整改过程中是否出现新增问题。"
    },
    {
      question: "江苏和上海地区是否可以预约业主验房？",
      answer: "可以根据房屋所在城市和时间安排沟通。服务区域覆盖江苏、上海及长三角区域，具体上门时间需结合现场条件确认。"
    }
  ]
};

export const homeFaqs = [
  {
    question: "江苏道鼎升主要服务哪些客户？",
    answer: "当前主要面向开发商、建设单位、物业单位、工程项目和住宅交付项目，提供精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、整改复查和工程质量检测服务。"
  },
  {
    question: "对公工程查验是否只在房屋交付时进行？",
    answer: "不是。对公服务可以在小区精装入场阶段同步进场，参与过程查验、质量跟踪、问题记录、整改复查和交付前质量管控。"
  },
  {
    question: "精装入场查验的价值是什么？",
    answer: "精装入场查验可以在批量装修前发现移交条件、基层质量、渗漏风险和前置问题，减少后期集中返工和交付投诉风险。"
  },
  {
    question: "分户查验和一房一验会输出什么？",
    answer: "可按户输出问题清单、照片记录、位置说明、问题分类和整改建议，也可按楼栋、批次或专业维度形成汇总资料。"
  },
  {
    question: "整改复查如何形成闭环？",
    answer: "整改复查会基于前期问题清单逐项核对，记录已整改、未整改、整改不到位和新增问题，帮助项目继续推进质量整改。"
  },
  {
    question: "服务覆盖哪些区域？",
    answer: "公司服务覆盖江苏、上海及长三角区域，包括南京、苏州、无锡、常州、南通、扬州、镇江、泰州等城市及周边区域。"
  },
  {
    question: "个人业主是否可以预约验房？",
    answer: "可以。个人业主验房已单独设置为对私服务入口，主要面向新房、精装房、毛坯房和收房陪验场景，但首页定位仍以对公工程查验为主。"
  }
];

export const projectCases = [
  {
    name: "上海光合上城",
    title: "上海光合上城｜精装房交付查验项目",
    image: "/img/service-entry-inspection.webp",
    projectType: "精装住宅交付",
    service: "精装入场查验、分户查验、问题记录、整改建议、查验报告",
    result: "输出分户问题清单、问题照片记录、整改建议和阶段性查验报告。",
    value: "帮助项目提前发现交付质量问题，降低集中交付投诉风险。"
  },
  {
    name: "苏州保利融信云上流光",
    title: "苏州保利融信云上流光｜批量交付前查验项目",
    image: "/img/pre-delivery-acceptance.webp",
    projectType: "住宅集中交付",
    service: "交付前预验收、分户问题记录、每日问题汇总、整改跟踪建议",
    result: "形成陪验记录、每日问题汇总、高频问题反馈和整改跟踪建议。",
    value: "配合项目交付节奏，提高现场问题记录效率，支持交付团队快速响应。"
  },
  {
    name: "南京金陵中心",
    title: "南京金陵中心｜工程质量检测与过程巡检项目",
    image: "/img/process-quality-patrol.webp",
    projectType: "综合住宅项目",
    service: "过程质量巡检、专项质量检查、数据汇总、检测报告",
    result: "输出专项问题清单、阶段性汇总、偏差统计和检测报告。",
    value: "通过过程记录识别质量风险，为项目整改决策提供依据。"
  }
];

export const detailedCases = [
  {
    id: 1,
    title: "上海光合上城｜精装房交付查验项目",
    image: "/img/service-entry-inspection.webp",
    city: "上海",
    projectType: "精装住宅",
    services: ["精装入场查验", "分户查验", "问题记录", "整改建议", "查验报告"],
    serviceObject: "开发商、项目交付团队、物业公司",
    background: "精装住宅集中交付前，项目需要提前识别户内观感、功能、安装和渗漏等质量风险，形成可整改的问题记录。",
    scope: ["精装入场与交付前质量查验", "墙地面与顶面观感", "门窗与五金安装", "厨卫与给排水", "电气点位与设备安装", "渗漏与空鼓风险"],
    typicalProblems: ["墙地面空鼓开裂", "门窗启闭或密封问题", "厨卫收口瑕疵", "给排水功能异常", "局部渗漏隐患"],
    result: "按分户维度记录墙地面、门窗、厨卫、给排水、电气及收口问题，帮助项目在集中交付前识别高频质量风险。",
    value: "提前发现交付质量问题，降低集中交付阶段的沟通压力和投诉风险。",
    deliverables: ["分户查验清单", "问题照片记录", "整改建议", "阶段性汇总报告"],
    relatedServices: ["jingzhuang-entry-inspection", "household-inspection", "recheck"]
  },
  {
    id: 2,
    title: "苏州保利融信云上流光｜批量交付前查验项目",
    image: "/img/pre-delivery-acceptance.webp",
    city: "苏州",
    projectType: "住宅交付",
    services: ["交付前预验收", "分户问题记录", "每日问题汇总", "整改跟踪建议"],
    serviceObject: "开发商交付团队、物业公司、客户关系团队",
    background: "住宅项目集中交付时，业主到访集中、问题记录密集，项目需要第三方人员协助现场查验与分类汇总。",
    scope: ["交付前预验收", "分户问题记录", "每日问题汇总", "高频问题反馈", "整改跟踪建议"],
    typicalProblems: ["业主集中反馈问题多", "现场记录口径不统一", "跨部门整改协同压力大", "高频问题缺少汇总"],
    result: "结合交付批次配置查验人员，协助项目完成现场问题记录、分类整理和每日汇总。",
    value: "让交付现场的问题记录更标准，方便项目客服、工程和施工单位协同跟进。",
    deliverables: ["预验收记录表", "每日问题汇总", "高频问题反馈", "整改跟踪建议"],
    relatedServices: ["pre-delivery-acceptance", "household-inspection", "recheck"]
  },
  {
    id: 3,
    title: "南京金陵中心｜工程质量检测与过程巡检项目",
    image: "/img/process-quality-patrol.webp",
    city: "南京",
    projectType: "综合住宅项目",
    services: ["过程质量巡检", "专项质量检查", "数据汇总", "检测报告"],
    serviceObject: "开发商工程管理部、建筑企业、项目管理方",
    background: "项目施工与交付管理阶段，需要通过过程查验和专项检测识别施工偏差，并为质量整改提供依据。",
    scope: ["过程节点巡检", "垂直度和平整度测量", "阴阳角方正度", "开间进深与净高", "门窗洞口尺寸", "偏差统计与分析"],
    typicalProblems: ["墙面垂直度偏差", "地面平整度不足", "阴阳角方正度问题", "空间尺寸偏差", "洞口尺寸不一致"],
    result: "围绕过程质量、实测实量及重点部位质量进行数据化记录。",
    value: "为施工质量管理提供数据依据，辅助项目识别系统性偏差和整改重点。",
    deliverables: ["过程巡检清单", "偏差统计", "专项问题清单", "检测报告"],
    relatedServices: ["process-quality-patrol", "quality-inspection", "recheck"]
  },
  {
    id: 4,
    title: "上海海玥黄浦源｜公共部位与交付前查验项目",
    image: "/img/process-quality-patrol.webp",
    city: "上海",
    projectType: "住宅项目",
    services: ["过程质量巡检", "公共部位检查", "渗漏风险排查", "问题清单输出"],
    serviceObject: "开发商、建筑企业、物业公司",
    background: "住宅交付前，需要对户内基础质量和公共部位进行排查，减少交付后集中整改压力。",
    scope: ["墙地顶空鼓裂缝", "门窗与栏杆检查", "给排水和电气预留", "厨卫阳台渗漏风险", "公共部位质量问题"],
    typicalProblems: ["墙面空鼓裂缝", "地面平整度问题", "外窗渗漏隐患", "排水不畅", "公共部位收口缺陷"],
    result: "对户内墙地顶、门窗、栏杆、厨卫、阳台及公共部位进行交付前质量排查。",
    value: "帮助项目在移交和交付前形成标准化整改清单，减少遗漏问题。",
    deliverables: ["交付前查验清单", "公共部位问题记录", "整改建议", "复查计划"],
    relatedServices: ["process-quality-patrol", "quality-inspection", "recheck"]
  }
];

export const newsArticles = [
  {
    id: 1,
    category: "公司动态",
    title: "江苏道鼎升持续完善对公工程查验与质量过程管控服务体系",
    date: "2026年6月",
    image: "/img/service-entry-inspection.webp",
    summary: "围绕住宅项目的精装入场、过程巡检、分户查验、交付前预验收和整改复查，公司持续优化对公工程查验服务流程。",
    points: ["精装入场同步查验", "过程质量巡检", "问题清单与报告输出规范化"],
    content: [
      {
        heading: "为什么要把查验前置到精装入场阶段",
        paragraphs: [
          "住宅项目交付前的质量风险往往并不是在交付当天才出现。基层移交、精装入场、样板段施工和批量装修过程中，如果问题没有被及时记录和整改，后期会放大为集中返工和交付投诉。",
          "江苏道鼎升围绕项目沟通、检测人员进场、分项查验记录、问题清单输出和整改复查，持续完善面向开发商、建设单位、物业单位和住宅交付项目的服务流程。"
        ]
      },
      {
        heading: "服务体系覆盖哪些项目需求",
        paragraphs: [
          "公司服务覆盖精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、整改复查和工程质量检测，可根据项目交付时间、户数和现场条件组合服务。",
          "服务对象以开发商、建设单位、物业单位、建筑企业、项目管理方和住宅交付项目为主，重点服务江苏、上海及长三角区域。"
        ]
      }
    ]
  },
  {
    id: 2,
    category: "服务体系",
    title: "质量管理流程建设为项目查验服务提供管理支撑",
    date: "2023年6月",
    image: "/img/issue-list-mockup.webp",
    summary: "质量管理流程建设有助于第三方检测服务在项目沟通、人员进场、问题记录、报告提交和整改复查等环节保持稳定输出。",
    points: ["流程管理更清晰", "报告输出更可追溯", "项目复盘和整改闭环更便于管理"],
    content: [
      {
        heading: "质量管理流程对检测服务的意义",
        paragraphs: [
          "工程查验和质量检测服务需要现场执行、记录标准和报告输出保持稳定。清晰的质量管理流程可以为服务范围、记录方式、报告交付和复查节点提供基础支撑。",
          "在项目服务过程中，质量管理体系有助于明确服务范围、记录方式、报告交付和复查节点，减少信息遗漏。"
        ]
      }
    ]
  },
  {
    id: 3,
    category: "行业洞察",
    title: "住宅集中交付前，为什么建议引入第三方工程查验服务？",
    date: "2026年6月",
    image: "/img/pre-delivery-acceptance.webp",
    summary: "集中交付前的问题高发点通常集中在精装修细部、门窗、厨卫、给排水、电气点位和渗漏风险。第三方查验可以帮助项目提前发现、记录并推动整改。",
    points: ["降低集中交付阶段问题堆积", "形成标准化问题清单", "为整改复查提供依据"],
    content: [
      {
        heading: "集中交付前的质量风险在哪里",
        paragraphs: [
          "住宅集中交付阶段，客户反馈的问题通常集中在精装修观感、门窗启闭、厨卫细节、给排水功能、电气点位和渗漏风险等方面。如果问题在交付现场集中暴露，会增加客服、工程和施工单位的沟通压力。",
          "第三方查验可以在正式交付前完成分户排查，把问题转化为标准化清单，并为施工单位整改提供依据。"
        ]
      }
    ]
  },
  {
    id: 4,
    category: "交付管理",
    title: "批量分户查验如何帮助项目降低现场沟通压力？",
    date: "2026年6月",
    image: "/img/household-inspection.webp",
    summary: "分户查验服务并不是替代项目方管理，而是在交付前补充专业查验、问题记录和分类汇总能力，帮助工程、客服、物业团队协同跟进。",
    points: ["人员排班匹配交付批次", "问题按户、楼栋、专业分类", "每日汇总支持现场复盘"],
    content: [
      {
        heading: "批量分户查验的工作重点",
        paragraphs: [
          "批量分户查验通常围绕交付批次、户数、现场动线和人员配置展开。第三方查验人员可协助完成分户查验、问题拍照、问题分类和阶段汇总。",
          "分户查验能帮助项目团队统一问题记录口径，让工程、物业和客服在同一套资料上协同推进。"
        ]
      }
    ]
  },
  {
    id: 5,
    category: "技术说明",
    title: "工程质量检测在住宅项目质量管理中的作用",
    date: "2026年6月",
    image: "/img/process-quality-patrol.webp",
    summary: "工程质量检测通过现场查验、专项问题记录和阶段性汇总，为项目质量管理提供可比较、可复核的依据。",
    points: ["识别施工偏差", "辅助施工单位整改", "支持阶段性质量评估"],
    content: [
      {
        heading: "工程质量检测为什么重要",
        paragraphs: [
          "工程质量检测将现场质量风险从零散反馈转化为可记录的清单和资料。通过阶段查验、专项检查和复查，项目团队可以更直观地识别问题来源和整改重点。",
          "这些资料可用于施工整改、质量评估和交付前复核。"
        ]
      }
    ]
  },
  {
    id: 6,
    category: "服务问答",
    title: "检测报告通常应包含哪些内容？",
    date: "2026年6月",
    image: "/img/report-sample-mockup.webp",
    summary: "检测报告应围绕查验范围、检测内容、问题描述、位置记录、照片、问题分类、整改建议和复查结果展开，避免只给笼统结论。",
    points: ["问题描述清楚", "照片与位置可追溯", "整改建议具备执行参考"],
    content: [
      {
        heading: "检测报告应包含哪些内容",
        paragraphs: [
          "一份面向项目交付的检测报告，通常需要包含查验范围、检测内容、问题描述、问题位置、照片记录、问题分类、整改建议和复查结果。",
          "报告的重点不是夸大问题，而是帮助项目团队明确问题、安排整改并形成后续复查依据。"
        ]
      }
    ]
  }
];

export const trustItems = [
  "第三方工程查验视角",
  "精装入场同步查验",
  "过程质量巡检",
  "分户问题清单",
  "整改复查闭环",
  "覆盖江苏、上海及长三角区域"
];
